var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{class:_vm.$style.button,attrs:{"loading":_vm.loading,"disabled":_vm.countdown > 0},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.countdown > 0 ? (_vm.countdown + "s 后重试") : "获取验证码")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }